import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import axios from 'axios'

import BootstrapVue from 'bootstrap-vue'
import vbclass from 'vue-body-class'

import msgBR from 'vee-validate/dist/locale/pt_BR'
import VeeValidate, {Validator} from 'vee-validate'

import VueTheMask from 'vue-the-mask'
import money from 'v-money-plus'

import directives from '@/directives';
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
// Excel
import JsonExcel from 'vue-json-excel';
Vue.component('downloadExcel', JsonExcel);
//
Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead)

Vue.use(money, {decimal: ',', thousands: '.', prefix: 'R$ ', suffix: '', precision: 2, masked: false})
Vue.use(VueTheMask)

Vue.use(VeeValidate)
Validator.localize('pt_BR', msgBR)

Vue.config.productionTip = false

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import './assets/css/main.css'
import './assets/styles/style-custom.scss'

import 'vue-multiselect/dist/vue-multiselect.min.css'

import moment from "moment";

import endpoint from './endpoint'

axios.defaults.baseURL = endpoint.urlGrupoSin

axios.interceptors.request.use(function(config) {
  const token = store.getters.token;
  const user = store.getters.user;
  // eslint-disable-next-line
  console.log(config.url.indexOf('/api/login/writeLabel'));

  if (config.url.indexOf('/api/login/writeLabel') >= 0
      || config.url.indexOf('https://viacep.com.br/ws/') >= 0) {
    // eslint-disable-next-line
    console.log('CONFIG', config);
    return config;
  }

  // eslint-disable-next-line
  console.log('token', token);
  // eslint-disable-next-line
  console.log('USER INTERCEPTOR', store.getters.user);
  if ( token != null ) {
    config.headers['x-access-token'] = `${token}`;
    config.headers['x-key'] = user.username;
  }

  return config;
}, function(err) {
  return Promise.reject(err);
});

window.$ = window.jQuery = require('jquery')

Vue.use(vbclass, router)
Vue.use(BootstrapVue)

Vue.filter('formatDate', function (value){
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY HH:mm:ss')
  }
  return '';
});

Vue.filter('truncate', function (value, limit) {
  if (value && value.length > limit) {
      value = value.substring(0, (limit - 3)) + '...';
  }

  return value
});

new Vue({
  router,
  store,
  directives,
  render: h => h(App)
}).$mount('#app')
